import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const UserSquareIcon: React.FC<ISvgIcons> = ({
    className = "",
    ...rest
}) => (
    <svg
        viewBox="0 0 24 24"
        className={`${className}`}
        stroke="currentColor"
        stroke-width="1.5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...rest}
    >
        <path d="M18.1401 21.6207C17.2601 21.8807 16.2201 22.0007 15.0001 22.0007H9.00011C7.78011 22.0007 6.74011 21.8807 5.86011 21.6207C6.08011 19.0207 8.75011 16.9707 12.0001 16.9707C15.2501 16.9707 17.9201 19.0207 18.1401 21.6207Z" />
        <path d="M15 2H9C4 2 2 4 2 9V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z" />
        <path d="M15.5799 10.58C15.5799 12.56 13.9799 14.17 11.9999 14.17C10.0199 14.17 8.41992 12.56 8.41992 10.58C8.41992 8.60002 10.0199 7 11.9999 7C13.9799 7 15.5799 8.60002 15.5799 10.58Z" />
    </svg>
)
